import React from 'react';

import pp from 'assets/pictures/pp.jpeg';
import { WHO_I_AM } from 'constants/texts';
import { SECTIONS } from 'constants/sections';

import Section from 'components/Section';

import './styles.scss';

function AboutMe() {
  return (
    <Section name={SECTIONS.WHO_I_AM.name}>
      <div className="first-column">
        <h1 className="title">{WHO_I_AM.title}</h1>
        <p className="paragraph">{WHO_I_AM.content}</p>
      </div>
      <div className="second-column profile-picture-container">
        <img className="profile-picture" src={pp} alt="Enrique Mejia"/>
      </div>
    </Section>
  )
}

export default AboutMe;
